import { gql, useQuery } from "@apollo/client";

export interface CurrentUserPermission {
  id: string;
  description?: string;
}

export interface CurrentUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  permissions: CurrentUserPermission[];
}

const CURRENT_USER_QUERY = gql`
  query CurrentUser {
    current_user {
      id
      firstName
      lastName
      email
      permissions {
        id
        description
      }
    }
  }
`;

export function useCurrentUser() {
  const { data, loading, error } = useQuery(CURRENT_USER_QUERY);
  const currentUser: CurrentUser | null = data?.current_user ?? null;
  const permissions: CurrentUserPermission[] = currentUser?.permissions ?? [];

  function hasPermission(permission: string): boolean {
    return permissions.some((p) => p.id === permission);
  }

  return { currentUser, permissions, loading, error, hasPermission };
}
